import { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import BaseModal from "../components/BaseModal";

interface RevisionModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export default function RevisionModal({ open, loading, onClose, onConfirm }: RevisionModalProps) {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason.trim());
    }
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <BaseModal
      open={open}
      title="Revision required"
      loading={loading}
      confirmLabel="Send revision request"
      confirmDisabled={!reason.trim()}
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <Box display="flex" flexDirection="column" gap={1.5}>
        <Typography fontSize="14px" lineHeight="20px">
          The vendor will be asked to correct and resubmit.
        </Typography>
        <Box>
          <Typography fontSize="14px" lineHeight="20px" mb={1.5}>
            Enter revision reason
          </Typography>
          <TextField
            autoFocus
            fullWidth
            placeholder="Text"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 48,
                borderRadius: "4px",
                "& fieldset": { borderColor: "#CCC" },
              },
            }}
          />
        </Box>
      </Box>
    </BaseModal>
  );
}
